import * as api from '@/api/chat'
import * as TYPES from './type';

export default {
  //在线答疑
  async getChatStuList({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqChatStuList(paramets)
    commit(TYPES.CHAT_STU_LIST, { result })
    cb && cb()
  },
  async getChatDetail({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqChatDetail(paramets)
    commit(TYPES.CHAT_DETAIL, { result })
    cb && cb()
  },
  async postChatReplyStu({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqChatReplyStu(paramets)
    commit(TYPES.CHAT_REPLAY_STU, { result })
    cb && cb()
  },
  async delPlanDel({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqPlanDel(paramets)
    commit(TYPES.CHAT_DEL, { result })
    cb && cb()
  },
  // 教学讨论编辑
  async talkEditTalk({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqEditTalk(paramets)
    commit(TYPES.CHAT_EDIT, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/chat/actions.js